module.exports = __webpack_public_path__ + "img/sbbj.21f0e696.png";